// extracted by mini-css-extract-plugin
export var header = "footer-links-module--header--0866a";
export var list = "footer-links-module--list--9c874";
export var wrap = "footer-links-module--wrap--8aa03";